import React from 'react';

import Skeleton from '../Skeleton/Skeleton';

import { Pill } from '../Pill/Pill';
import styles from './contract-header.module.scss';

interface IContractHeaderPillsItemProps {
  label: string,
  isLoading?: boolean,
  pills: string[]
  labelSuffix?: React.ReactNode;
}


export default function ContractHeaderPillsItem({
  label,
  isLoading,
  pills,
  labelSuffix,
}: IContractHeaderPillsItemProps): JSX.Element {

  const getContractHeaderPills = () => {
    return pills.length ? pills.map((el: string) => (
      <div key={el} className={styles.tag}>
        <Pill size="large">{el}</Pill>
      </div>
    )) : '—';
  };

  return (
    <div className={styles['contract-header']}>
      <span className={styles.label}>{label}{labelSuffix}</span>

      {isLoading ? (
        <Skeleton
          count={1}
        />
      ) : (
        <div className={styles.tags}>
          {getContractHeaderPills()}
        </div>
      )}
    </div>
  );
}


